import React from 'react';
import Dock from '../ui/Dock';
import { Home, Briefcase, Users, Mail } from 'lucide-react';

interface DockSectionProps {
  onNavigate: (page: 'home' | 'services' | 'teams' | 'contact') => void;
}

// Wrap DockSection in React.memo for performance
const DockSection: React.FC<DockSectionProps> = React.memo(({ onNavigate }) => {
  const dockItems = [
    { 
      icon: <Home size={20} className="text-white" />, 
      label: 'Home', 
      onClick: () => onNavigate('home') 
    },
    { 
      icon: <Briefcase size={20} className="text-white" />, 
      label: 'Services', 
      onClick: () => onNavigate('services') 
    },
    { 
      icon: <Users size={20} className="text-white" />, 
      label: 'Team', 
      onClick: () => {
        console.log('Teams button clicked!');
        onNavigate('teams');
      }
    },
    { 
      icon: <Mail size={20} className="text-white" />, 
      label: 'Contact', 
      onClick: () => {
        console.log('Contact button clicked!');
        onNavigate('contact');
      }
    },
  ];

  return (
    <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50" style={{ willChange: 'transform, opacity' }}>
      <Dock 
        items={dockItems}
        panelHeight={80}
        baseItemSize={60}
        magnification={90}
        className="bg-white/10 backdrop-blur-2xl border-white/20"
      />
    </div>
  );
});

export default DockSection; 